import React, { FC } from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { ParkingPageId } from '../../../domain/pages/ParkingPageId';
import { Payment } from '../../booking-steps/payment';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { BookingPageLayout } from '../shared/BookingPageLayout';
import { useHideChatBot } from '../../../../chatbot/helpers/useHideChatBot';

export const NewBookingPaymentPage: FC = () => {
	useHideChatBot('mobile');
	const { t } = useTranslation();
	const parentUrl = useUrlForPageId(ParkingPageId.NewBookingDetails);
	const nextUrl = useUrlForPageId(ParkingPageId.NewBookingConfirmation);
	const sessionExpiredNextUrl = useUrlForPageId(
		ParkingPageId.NewBookingAvailability,
	);
	const parkingOptionsUrl = useUrlForPageId(
		ParkingPageId.NewBookingAvailability,
	);

	return (
		<BookingPageLayout
			parentUrl={parentUrl}
			parentTitle={t('web_parking_payment_back_button')}
			title={t('web_parking_payment_header')}
		>
			<Payment
				nextUrl={nextUrl}
				sessionExpiredNextUrl={sessionExpiredNextUrl}
				changeButtonUrl={parkingOptionsUrl}
			/>
		</BookingPageLayout>
	);
};
